import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'categories-layout_element-view';

/**
 * This is the Categories Layout Element View event
There are 3 parameter tokens:
1. Container name (On click event name)
2. Request id
3. List of brands/products if applicable
 */
export function trackCategoriesLayoutElementView(
  customParameterToken: string,
  customParameterToken2: string,
  customParameterToken3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      customParameterToken,
      customParameterToken2,
      customParameterToken3,
    },
  });
}
